import React, { useMemo, useEffect, useState, useContext } from 'react';
import classnames from 'classnames';
import Modal from 'react-modal';
import CloseIcon from '../../../Icons/CloseBold';
import { IconSize } from '../../../Icons/IconWrap';
import { MobileContext } from '../../../Context';
import { ScreenSizeContext } from '../../../Measured';
import { parse as parseSrcSet } from '../../../utils/srcset';
import s from './Image.scss';
function isBiggerThanViewport(width, height) {
    if (typeof window === 'undefined' || !width || !height) {
        return false;
    }
    return width > window.innerWidth || height > window.innerHeight;
}
var ZoomStage;
(function (ZoomStage) {
    ZoomStage[ZoomStage["INITIAL"] = 0] = "INITIAL";
    ZoomStage[ZoomStage["EXPANDED"] = 1] = "EXPANDED";
})(ZoomStage || (ZoomStage = {}));
export var ZoomModal = function (_a) {
    var src = _a.src, srcSet = _a.srcSet, width = _a.width, height = _a.height, isPixel = _a.isPixel, onClose = _a.onClose;
    var _b = useState(ZoomStage.INITIAL), zoomStage = _b[0], setZoomStage = _b[1];
    var isMobile = useContext(MobileContext);
    var screenWidth = useContext(ScreenSizeContext).width;
    var largestImage = useMemo(function () {
        return parseSrcSet(srcSet || '')
            .concat({ width: width, height: height, url: src })
            .filter(function (source) { return source.width; })
            .sort(function (_a, _b) {
            var _c = _a.width, a = _c === void 0 ? 0 : _c;
            var _d = _b.width, b = _d === void 0 ? 0 : _d;
            return a - b;
        })
            .pop();
    }, [srcSet, width, height, src]);
    var maxWidth = Math.max((largestImage === null || largestImage === void 0 ? void 0 : largestImage.width) || 0, screenWidth);
    var canZoom = isBiggerThanViewport(width, height);
    // close when escape is used
    useEffect(function () {
        function onKeyDown(e) {
            if (e.key === 'Escape') {
                onClose();
            }
        }
        window.addEventListener('keydown', onKeyDown);
        return function () { return window.removeEventListener('keydown', onKeyDown); };
    }, [onClose]);
    var toggleZoomStage = function () {
        if (canZoom) {
            // For mobile, we only want the initial zoom mode, then users can pinch+zoom all they want.
            if (zoomStage === ZoomStage.INITIAL && !isMobile) {
                setZoomStage(ZoomStage.EXPANDED);
            }
            else {
                setZoomStage(ZoomStage.INITIAL);
            }
        }
    };
    var isZoomed = canZoom && zoomStage === ZoomStage.EXPANDED;
    // wrapping in a modal to avoid the can of worms with scrolling the underlying page and all
    // NoLeakyScroll only goes that far, and this seems more performant overall
    return (React.createElement(Modal, { className: classnames(s['zoom-content'], zoomStage === ZoomStage.EXPANDED && s['zoom-content-expanded']), isOpen: true, overlayClassName: s['zoomed'], onRequestClose: onClose },
        React.createElement("button", { className: s['unzoom'], onClick: onClose },
            React.createElement(CloseIcon, { size: IconSize.BIG, className: s['unzoom-icon'] })),
        React.createElement("div", { className: s['zoom-viewport'] },
            React.createElement("img", { alt: "", className: classnames(s['image'], isPixel && s['pixel'], canZoom && zoomStage === ZoomStage.INITIAL && s['initial-zoom'], canZoom && zoomStage === ZoomStage.EXPANDED && s['expanded-zoom']), src: isZoomed && (largestImage === null || largestImage === void 0 ? void 0 : largestImage.url) ? largestImage.url : src, style: isZoomed ? { maxWidth: maxWidth } : undefined, onClick: toggleZoomStage }))));
};
ZoomModal.displayName = 'ZoomModal';
export default ZoomModal;
//# sourceMappingURL=ZoomModal.js.map